import { motion } from "framer-motion";
import { X, Maximize2, Minimize2, History, Plus } from "lucide-react";
import AIAvatar from "./AIAvatar";

export default function ChatHeader({
  title, online = true, expanded, onToggleSidebar, onToggleExpand, onClose, onNew,
}) {
  return (
    <motion.header
      className="ai-header"
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="ai-header-left">
        <button type="button" className="ai-header-iconbtn" onClick={onToggleSidebar} title="History">
          <History size={15} />
        </button>
        <div className="ai-header-id">
          <AIAvatar size={30} />
          <div>
            <div className="ai-header-title">
              Brixigo AI
              <span className={`ai-header-status ${online ? "is-online" : ""}`}>
                <span className="ai-header-statusdot" />
                {online ? "Online" : "Offline"}
              </span>
            </div>
            <div className="ai-header-sub">
              {title ? title : "Powered by Brixigo Intelligence"}
            </div>
          </div>
        </div>
      </div>
      <div className="ai-header-right">
        <button type="button" className="ai-header-iconbtn" onClick={onNew} title="New chat">
          <Plus size={15} />
        </button>
        <button type="button" className="ai-header-iconbtn" onClick={onToggleExpand} title={expanded ? "Collapse" : "Expand"}>
          {expanded ? <Minimize2 size={15} /> : <Maximize2 size={15} />}
        </button>
        <button type="button" className="ai-header-iconbtn ai-header-close" onClick={onClose} title="Close">
          <X size={16} />
        </button>
      </div>
    </motion.header>
  );
}
